import React from 'react';
import { AnimatedSection } from './AnimatedSection';
import { ArrowDown } from 'lucide-react';
export function HeroSection() {
  return <section className="w-full px-6 pt-12 pb-20 md:pt-20 md:pb-32 flex flex-col items-center" data-id="element-19">
      <AnimatedSection className="max-w-2xl w-full mx-auto text-center mb-12" data-id="element-20">
        <span className="inline-block px-3 py-1 mb-6 text-xs font-medium tracking-widest text-terracotta uppercase border border-terracotta/30 rounded-full bg-terracotta/5" data-id="element-21">
          Para mujeres 40+
        </span>

        <h1 className="text-4xl md:text-6xl font-serif font-medium text-charcoal leading-tight mb-8" data-id="element-22">
          No es que te falte fuerza: <br data-id="element-23" />
          <span className="italic text-terracotta" data-id="element-24">te falta un protocolo.</span>
        </h1>

        <p className="text-lg md:text-xl text-charcoal/80 leading-relaxed max-w-xl mx-auto mb-10" data-id="element-25">
          El duelo a los 40+ no se "supera". Se administra. <br data-id="element-26" />
          30 días para dejar de recaer en el mismo dolor.
        </p>

        <div className="relative w-full max-w-md mx-auto aspect-[3/4] md:aspect-[4/3] shadow-2xl rounded-sm overflow-hidden mb-6 bg-stone" data-id="element-27">
          <img src="https://cdn.magicpatterns.com/uploads/i2Wo9Kb6ncaEsjjNfquvrc/libro_portada.png" alt="Portada del libro Duelo Libre 40+" className="w-full h-full object-cover" data-id="element-28" />
        </div>

        <div className="mb-12" data-id="element-29">
          <button onClick={() => document.getElementById('comprar')?.scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        })} className="px-10 py-4 bg-terracotta hover:bg-terracotta/90 text-white text-lg font-medium tracking-wide rounded-sm shadow-lg hover:shadow-xl transform hover:-translate-y-0.5 transition-all duration-200 flex items-center gap-2 mx-auto" data-id="element-30">
            <span data-id="element-31">Empezar Hoy</span>
            <ArrowDown size={20} data-id="element-32" />
          </button>
        </div>
      </AnimatedSection>

      <AnimatedSection delay={0.2} className="max-w-xl w-full mx-auto space-y-6 text-lg leading-relaxed text-charcoal/90 border-l-2 border-terracotta/30 pl-6 md:pl-8 py-2" data-id="element-33">
        <p data-id="element-34">Te levantas.</p>
        <p data-id="element-35">
          Y antes de lavarte la cara ya pasó lo mismo otra vez: tu cabeza empezó
          a negociar con el dolor.
        </p>
        <p className="italic text-charcoal/70" data-id="element-36">"Hoy sí voy a estar bien."</p>
        <p className="italic text-charcoal/70" data-id="element-37">"Hoy no lo voy a pensar."</p>
        <p className="italic text-charcoal/70" data-id="element-38">"Hoy no le voy a escribir."</p>
        <p data-id="element-39">Y a las 11:47 pm… vuelves a caer en el mismo lugar.</p>
        <p className="font-medium" data-id="element-40">
          No porque seas débil. Porque estás intentando atravesar un duelo de
          adulta… sin un sistema de adulta.
        </p>
      </AnimatedSection>

      <div className="mt-16 animate-bounce text-terracotta/60" data-id="element-41">
        <ArrowDown size={24} data-id="element-42" />
      </div>
    </section>;
}